import { render } from "./UserProfilePage.vue?vue&type=template&id=55f0fa28"
import script from "./UserProfilePage.vue?vue&type=script&lang=js"
export * from "./UserProfilePage.vue?vue&type=script&lang=js"
script.render = render

export default script